/* eslint-disable no-undef,react/no-danger */
import React, { Component } from "react";
import PropTypes from "prop-types";
// import Promise from 'bluebird';
import { connect } from "react-redux";
import reduxForm from "redux-form/lib/reduxForm";
import formPropTypes from "redux-form/lib/propTypes";
import formActions from "redux-form/lib/actions";
import SubmissionError from "redux-form/lib/SubmissionError";
import getFormSubmitErrors from "redux-form/lib/getFormSubmitErrors";
import getFormAsyncErrors from "redux-form/lib/getFormAsyncErrors";
import getFormSyncErrors from "redux-form/lib/getFormSyncErrors";
import formValueSelector from "redux-form/lib/formValueSelector";
import { translate } from "react-i18next";
import withRouter from "react-router/withRouter";
import debounce from "lodash/debounce";
import ReactTooltip from "react-tooltip";
import Immutable from "immutable";
import { createSelector } from "reselect";

import $ from "jquery";
import { hot } from "react-hot-loader";
import isEqual from "lodash/isEqual";

import "./Cart.scss";

import createSchemaValidator from "./schema";
import { pushDataLayerEvent } from "../../store/modules/app";
// eslint-disable-next-line max-len
import {
  initialize as initCart,
  calculate as calcCart,
  submitCart,
  hydrateContext,
  setActiveStep,
  formClearAsyncErrors,
  formClearSyncErrors
} from "../../store/modules/cart";
import { hasContextInfluencingCartStuff } from "./util";
import { ajvErrorMapperCreator, reduxFormOnSubmitFailScrollToFirstError, handleSubmitError } from "../../lib/formUtils";
import Clock from "../Clock";
import Step1 from "./Step1";
import RecipientsStep from "./RecipientsStep";
import CustomerDetailsStep from "./CustomerDetailsStep";
import Overview from "./Overview";
import CheckoutStep from "./CheckoutStep";
import Spinner from "../../component/Spinner";
import StickyContainer from "../../containers/StickyContainer";
import { price, hasClass } from "../../lib/utils";
import ReadMore from "../../component/ReadMore";
import ProductImageGallery from "./Step1/ProductImageGallery";
import FormErrorOverview from "./FormErrorOverview";

const EMPTY_MAP = Immutable.Map();

if (!window.logSchemaErrors && window.console.log) {
  // eslint-disable-next-line no-console,no-unused-expressions
  console.log("window.logSchemaErrors = false");
}

const BUTTON_SPINNER_STYLE = {
  maxWidth: 16,
  maxHeight: 16,
  minWidth: 16,
  minHeight: 16,
  marginRight: 7
};

const noop = () => {};

const validate = (data, props, field) => {
  if (__DEV__) {
    // eslint-disable-next-line no-console
    console.log("validate data", data, field);
  }
  // console.log('asyncValidate', props);
  const isValid = props.schemaValidator.validate("Cart", data);
  if (__DEV__) {
    // eslint-disable-next-line no-console
    console.log("isValid", isValid, field);
  }

  const errors = {};
  if (!isValid) {
    // eslint-disable-next-line no-console,no-unused-expressions
    if ((window.logSchemaErrors || __DEV__) && window.console.log) {
      window.console.log("ajv.errors", props.schemaValidator.errors);
    }
    // eslint-disable-next-line no-console,no-unused-expressions
    props.schemaValidator.errors.map(ajvErrorMapperCreator(errors, props.schema, props.t));
  }

  if (__DEV__ || window.logSchemaErrors) {
    // eslint-disable-next-line no-console
    console.log("form.errors", errors);
  }
  return errors;
};

class Container extends Component {
  static propTypes = {
    ...formPropTypes,
    pushDataLayerEvent: PropTypes.func.isRequired,
    submitCart: PropTypes.func.isRequired,
    blurField: PropTypes.func.isRequired,
    hydrateContext: PropTypes.func.isRequired,
    isHydratingContext: PropTypes.bool.isRequired,
    canFinalize: PropTypes.bool.isRequired,
    isBusinessAccount: PropTypes.bool.isRequired,
    isCurrentItemInCart: PropTypes.bool.isRequired,
    isFirstShow: PropTypes.bool.isRequired,
    activeStep: PropTypes.number.isRequired,
    webProductCollection: PropTypes.instanceOf(Immutable.Map).isRequired
  };

  static childContextTypes = {
    isSafari: PropTypes.bool,
    showStepNumbers: PropTypes.bool,
    asyncValidate: PropTypes.func,
    activeStep: PropTypes.number
  };

  constructor() {
    super();

    this.containerRef = React.createRef();
    this.onDebounceContextUpdate = debounce(this.onContextUpdate, 200);
  }

  state = {
    step2IsValid: false,
    step3IsValid: false,
    step4IsValid: false,
    isRecipientsActive: true
  };

  getChildContext() {
    return {
      activeStep: this.props.activeStep,
      isSafari: this.props.isSafari,
      showStepNumbers: !(this.props.currentItemContext === null || this.props.currentItemContext.size === 0),
      asyncValidate: this.props.asyncValidate
    };
  }

  // eslint-disable-next-line react/sort-comp
  tryOpenCartOverviewCurrentStep(props) {
    if (props.currentItemContext && props.currentItemContext.size) {
      return;
    }
    if (__DEV__) {
      // eslint-disable-next-line no-console
      console.log("tryOpenCartOverviewCurrentStep.formValues", props.formValues);
    }
    const errors = validate(props.formValues, props);

    if (__DEV__) {
      // eslint-disable-next-line no-console
      console.log("tryOpenCartOverviewCurrentStep.errors", errors);
    }
    const keys = Object.keys(errors);
    if (!keys.length || keys[0] === "checkout") {
      this.setState({
        step2IsValid: true,
        step3IsValid: true,
        isRecipientsActive: true
      });
      props.setActiveStep(4);
      return;
    }
    if (keys[0] === "recipients") {
      props.setActiveStep(2);
      return;
    }
    if (keys[0] === "customer") {
      this.setState({ step2IsValid: true, isRecipientsActive: true });
      props.setActiveStep(3);
      return;
    }
    props.setActiveStep(2);
  }

  componentWillMount() {
    this.props.calcCart();
    this.tryOpenCartOverviewCurrentStep(this.props);
  }

  componentWillReceiveProps(props) {
    if (hasContextInfluencingCartStuff(this.props.formValues, props.formValues)) {
      this.onDebounceContextUpdate(props.formValues);
    }
    // hm crappy way to get past initialValue limits
    if (props.formValues && props.formValues.recipients) {
      props.formValues.recipients.forEach((recipient, idx) => {
        const recipientContext = props.context.getIn(["recipientContexts", idx]);
        if (!recipientContext) {
          return;
        }
        const availableCards = recipientContext.get("availableCards");
        if (!availableCards) {
          return;
        }
        const cardId = recipient.card && recipient.card.type;
        if (!availableCards.find(c => c.get("id") === cardId)) {
          this.props.changeField("cart", `recipients[${idx}].card.type`, recipientContext.get("defaultCard"));
        }
      });
    }

    if (props.formValues && props.formValues.items && props.formValues.items.length === 0) {
      if (props.activeStep !== 1) {
        this.props.setActiveStep(1);
      }
    }
    if (typeof this.props.formValues === "undefined" && typeof props.formValues !== "undefined") {
      this.tryOpenCartOverviewCurrentStep(props);
    }
  }

  shouldComponentUpdate(nextProps) {
    // for some reason this does not work in the connect() "areMergedPropsEqual" option
    return !isEqual(this.props, nextProps);
  }

  componentDidUpdate() {
    ReactTooltip.rebuild();
  }

  onContextUpdate = newInfluence => {
    this.props.calcCart();
    this.props.hydrateContext(newInfluence).then(() => {
      this.props.calcCart();
      if (__DEV__) {
        // eslint-disable-next-line no-console
        console.log("try to force validation?");
      }
      this.props.formClearAsyncErrors("cart");
      this.props.asyncValidate();
      this.props.formClearSyncErrors("cart");
    });
  };

  onDebounceContextUpdate = null;

  onSubmitOrder = data =>
    Promise.resolve()
      .then(() => {
        if (__DEV__) {
          // eslint-disable-next-line no-console
          console.log("onSubmitOrder");
        }
        if (!this.props.schemaValidator.validate("Cart", data)) {
          // eslint-disable-next-line no-console
          if (window.console && window.console.log) {
            if (__DEV__) {
              // eslint-disable-next-line no-console
              window.console.log("not valid", this.props.schemaValidator.errors);
            }
            if (window.Raven) {
              window.Raven.captureBreadcrumb({
                message: "onSubmitOrder validation client error",
                category: "cart",
                data: this.props.schemaValidator.errors,
                level: "info"
              });
              window.Raven.captureException("Validation client exception");
            }
          }
          const errors = {};
          if (__DEV__ || window.logSchemaErrors) {
            // eslint-disable-next-line no-console
            console.log("schema.errors", this.props.schemaValidator.errors);
          }
          this.props.schemaValidator.errors.map(ajvErrorMapperCreator(errors, this.props.schema, this.props.t));

          if (__DEV__ || window.logSchemaErrors) {
            // eslint-disable-next-line no-console
            console.log("form.errors", errors);
          }

          throw new SubmissionError({
            ...errors,
            _error: `${this.props.t("Submit failed")}: ${t("Check your details")}`
          });
        }
        if (__DEV__) {
          // eslint-disable-next-line no-console
          console.log("valid");
        }

        return this.props
          .submitCart(data)
          .then(res => {
            if (window.Raven) {
              window.Raven.captureBreadcrumb({
                message: `created order ${res.id}`,
                category: "payment",
                data: res.id,
                level: "info"
              });
            }
            window.document.location.href = `/payment?orderId=${res.id}`;
            return res;
          })
          .catch(err => {
            if (__DEV__) {
              // eslint-disable-next-line no-console
              console.error(err);
            }
            if (err.body) {
              if (__DEV__) {
                // eslint-disable-next-line no-console
                console.error(err.body);
              }
              if (window.Raven) {
                window.Raven.captureBreadcrumb({
                  message: "onSubmitOrder validation server error",
                  category: "cart",
                  data: err.body,
                  level: "info"
                });
                window.Raven.captureBreadcrumb({
                  message: "onSubmitOrder client data",
                  category: "cart",
                  data,
                  level: "info"
                });
                window.Raven.captureException("Validation server exception");
              }
              throw handleSubmitError(this.props.t, err.body);
            }
            throw new SubmissionError({
              _error: `${this.props.t("Submit failed")}: ${this.props.t("Unexpected error, try again")}`
            });
          });
      })
      .catch(err => {
        if (err instanceof SubmissionError && err.errors) {
          const keys = Object.keys(err.errors);
          if (!keys.length) {
            throw err;
          }
          const key = keys[0];
          if (key === "items") {
            this.props.setActiveStep(2);
          }
          if (key === "recipients") {
            this.props.setActiveStep(2);
          }
          if (key === "customer") {
            this.props.setActiveStep(3);
          }
          if (key === "checkout") {
            this.props.setActiveStep(4);
          }
        }
        throw err;
      });

  onForceValidate = () => {
    this.props.asyncValidate();
    setTimeout(() => {
      this.props.handleSubmit(noop)();
    }, 1);
  };

  onNextStep = e => {
    let isValid = true;

    const { isCartEmpty, isFirstShow, isAbTestOpenStep2 } = this.props;
    let { activeStep } = this.props;

    if (activeStep === 1 && !isCartEmpty && isFirstShow && isAbTestOpenStep2) {
      activeStep = 2;
    }

    if (activeStep > 1) {
      let data = this.props.formValues;
      switch (activeStep) {
        case 1:
          data = this.props.formValues.items;
          break;
        case 2:
          data = this.props.formValues.recipients;
          break;
        case 3:
          data = this.props.formValues.customer;
          break;
        case 4:
          data = this.props.formValues.checkout;
          break;
      }

      isValid = this.props.schemaValidator.validate(`Step${activeStep}`, data);
      if (isValid) {
        this.setState({
          [`step${activeStep}IsValid`]: isValid
        });
      }

      if (__DEV__) {
        // eslint-disable-next-line no-console
        console.log(`Step${activeStep}`, this.props.schemaValidator.errors);
      }
    }

    if (__DEV__) {
      // eslint-disable-next-line no-console
      console.log(`Step${activeStep}`, isValid);
    }
    if (!isValid) {
      this.props.blurField("cart", "recipient[0].address.zipcode");
      this.props.blurField("cart", "customer.emailAddress");
      this.props.blurField("cart", "checkout.termsAndConditions");
      this.props.touchField("cart", "checkout.termsAndConditions");
      this.props.changeField("cart", "checkout.termsAndConditions", false);
      this.props.asyncValidate();
      if (e) {
        e.persist();
      }
      setTimeout(() => {
        this.props.handleSubmit(noop)(e);
      }, 1);
      // this.props.handleSubmit(noopF)(e);
      return;
    }
    if (activeStep === 4) {
      this.props.handleSubmit(this.onSubmitOrder)(e);
      return;
    }
    this.props.formClearSyncErrors("cart");
    this.props.formClearAsyncErrors("cart");
    this.props.setActiveStep(activeStep + 1);

    this.onAnimateActiveStep(activeStep + 1);
  };

  onAnimateActiveStep = step => {
    this.props.pushDataLayerEvent({
      event: "activeCartStep",
      step
    });

    const $container = $(".Cart__Container");
    if ($container.length > 0 && $container.offset().top) {
      const htmlMarginTop = parseInt(
        $("html")
          .css("marginTop")
          .replace("px", "") || 0,
        10
      );
      $("html, body").animate(
        { scrollTop: $container.offset().top - $("#header").height() - 20 + htmlMarginTop },
        500,
        "linear"
      );
    }
  };

  onClickContinueShopping = () => {
    if (!this.props.webProductCollection) {
      window.document.location = "/";
    }
    window.document.location = this.props.webProductCollection.get("url", "/");
  };

  setRef = el => {
    this.step2El = el;
  };

  getClientSchemaValidationErrors() {
    if (!this.props.schemaValidator || !this.props.schemaValidator.errors) {
      return null;
    }
    const errors = {};
    this.props.schemaValidator.errors.map(ajvErrorMapperCreator(errors, this.props.schema, this.props.t));
    delete errors.checkout;
    return errors;
  }

  renderContinueButtons() {
    const { t, isCartEmpty } = this.props;
    return (
      <div className="Cart__Buttons">
        {!isCartEmpty && (
          <button type="button" className="btn btn-secondary" onClick={this.onNextStep}>
            {t("Next step", {
              step: 2,
              total: 4
            })}
          </button>
        )}
      </div>
    );
  }

  renderForm() {
    const { t, isFirstShow, currentItemContext, isKmtUser, isCartEmpty, activeStep } = this.props;

    const hasCurrentItemContext = currentItemContext && currentItemContext.get("webProductId", 0) !== 0;

    if (isKmtUser && hasCurrentItemContext) {
      return (
        <div className="Cart__Container">
          <Step1 isOpen showButton={false} isActive isKmtUser />
        </div>
      );
    }
    if (isKmtUser) {
      return (
        <div className="alert alert-danger">
          <h3>KMT gebruiker gedetecteerd</h3>
          Een bestelling plaatsen is niet mogelijk <a href="/logout#logout">Uitloggen</a>
        </div>
      );
    }

    if (hasCurrentItemContext && !currentItemContext.get("hasStock")) {
      return (
        <div className="Cart__Container">
          <Step1 isOpen showButton={false} isActive hasStock={false} />
        </div>
      );
    }

    // if this is a product page and the cart is not empty and the current item is not yet in the cart
    if (hasCurrentItemContext && !isCartEmpty && !this.props.isCurrentItemInCart) {
      return (
        <form className="Cart__Container" key="Cart__Container" ref={this.containerRef}>
          <Step1
            isOpen={activeStep === 1}
            onNextStep={this.onNextStep}
            scrollTo
            showButton={false}
            isActive
            isValid={activeStep > 1 && this.state.isRecipientsActive}
          />
        </form>
      );
    }

    const isAbTestOpenStep2 = !isCartEmpty && isFirstShow && this.props.isAbTestOpenStep2;

    return (
      <form className="Cart__Container" key="Cart__Container" ref={this.containerRef}>
        {hasCurrentItemContext && (
          <Step1
            isOpen={activeStep === 1 || (isAbTestOpenStep2 && !this.state.step2IsValid)}
            onNextStep={this.onNextStep}
            scrollTo
            showButton={false}
            isActive
            isValid={activeStep > 1 && this.state.isRecipientsActive}
          />
        )}
        {activeStep === 1 && !isAbTestOpenStep2 && hasCurrentItemContext && this.renderContinueButtons()}
        <div>
          {activeStep === 1 && !isAbTestOpenStep2 && <Overview key="cart_overview" />}

          {activeStep === 1 && !isAbTestOpenStep2 && !hasCurrentItemContext && this.renderContinueButtons()}

          <RecipientsStep
            step={2}
            isOpen={activeStep === 2 || (activeStep === 1 && isAbTestOpenStep2)}
            onNextStep={this.onNextStep}
            onForceValidate={this.onForceValidate}
            asyncValidate={this.props.asyncValidate}
            isActive={this.state.isRecipientsActive && !isCartEmpty}
            isValid={!isCartEmpty && this.state.step2IsValid}
            scrollTo={!hasCurrentItemContext}
            hasOverview
          />

          <CustomerDetailsStep
            step={3}
            isOpen={activeStep === 3}
            onNextStep={this.onNextStep}
            isActive={!isCartEmpty && this.state.step2IsValid}
            isValid={!isCartEmpty && this.state.step3IsValid}
            hasOverview
          />

          <CheckoutStep
            step={4}
            isOpen={activeStep === 4}
            onNextStep={false}
            isActive={!isCartEmpty && this.state.step3IsValid}
            isValid={!isCartEmpty && this.state.step4IsValid}
            hasOverview
          >
            {this.props.error && <div className="form-error has-danger invalid-feedback">{this.props.error}</div>}

            <FormErrorOverview
              schemaErrors={this.getClientSchemaValidationErrors()}
              submitFailed={this.props.submitFailed}
              submitErrors={this.props.formSubmitErrors}
              asyncErrors={this.props.formAsyncErrors}
              syncErrors={this.props.formSyncErrors}
              schema={this.props.schema}
            />

            <div className="d-flex justify-content-end mt-3  mb-3">
              <button
                type="button"
                disabled={this.props.submitting || this.props.submitSucceeded}
                className="btn btn-secondary bold"
                onClick={this.onNextStep}
              >
                <div className="d-flex flex-row align-items-center">
                  {(this.props.submitting || this.props.submitSucceeded) && (
                    <Spinner color="white" style={BUTTON_SPINNER_STYLE} strokeWidth={8} />
                  )}
                  <div>{t("Complete order")}</div>
                </div>
              </button>
            </div>
          </CheckoutStep>
        </div>
      </form>
    );
  }

  render() {
    const { t, isMobileView, isCartEmpty } = this.props;

    const hasCurrentItemContext =
      this.props.currentItemContext && this.props.currentItemContext.get("webProductId", 0) !== 0;

    if (!hasCurrentItemContext && isCartEmpty) {
      return (
        <div className="center">
          <div className="mb-3 mt-3">{t("Your cart is empty")}</div>
          <div>
            <button type="button" className="btn btn-inverted mr-2 mb-2" onClick={this.onClickContinueShopping}>
              {t("Continue shopping")}
            </button>
          </div>
        </div>
      );
    }

    if (isMobileView) {
      return [
        <Clock inCart key="ProductClock" />,
        <div className="Cart__Product" key="Cart__Product">
          <ProductImageGallery style={{ marginTop: "1.5rem", marginBottom: "1rem" }} />
          <div className="Cart__Product__Meta">
            {hasCurrentItemContext && (
              <h1 itemProp="name" key="ProductTitle">
                {this.props.context.getIn(["webProduct", "title"], "")}
              </h1>
            )}
            {hasCurrentItemContext && (
              <ReadMore
                className="Cart__Product__Description"
                key="ProductDescription"
                moreText={`${this.props.t("Read more")} >`}
                lessText={`${this.props.t("Read less")} <`}
                isExpanded={!this.props.isCurrentItemInCart}
                isAutoExpandedMQ={this.props.isCurrentItemInCart ? "" : "min-width: 1080px"}
              >
                <p
                  itemProp="description"
                  dangerouslySetInnerHTML={{
                    __html: this.props.context.getIn(["webProduct", "description"], "")
                  }}
                />
              </ReadMore>
            )}
            {hasCurrentItemContext && (
              <div className="Cart__Product__Price" key="ProductPrice">
                <div className="productcard__info__price__from">{this.props.t("from")}</div>
                <div className="productcard__info__price__currency">&euro;</div>
                <div className="productcard__info__price__price">
                  {price(this.props.currentItemContext.getIn(["items", 0, "priceIn"]), false)}
                </div>
              </div>
            )}
          </div>
        </div>,
        this.renderForm(),
        <ReactTooltip effect="solid" key="Cart__Tooltip" />
      ];
    }

    return [
      this.renderForm(),
      <div className="Cart__DiscountContainer" key="Cart__DiscountContainer">
        <StickyContainer>
          {hasCurrentItemContext && [
            <Clock inCart key="ProductClock" />,
            <h1 itemProp="name" key="ProductTitle">
              {this.props.context.getIn(["webProduct", "title"], "")}
            </h1>,
            <ReadMore
              className="Cart__Product__Description"
              moreText={`${this.props.t("Read more")} >`}
              lessText={`${this.props.t("Read less")} <`}
              isExpanded={!this.props.isCurrentItemInCart}
              isAutoExpandedMQ={this.props.isCurrentItemInCart ? "" : "min-width: 1080px"}
              key="ProductDescription"
            >
              <p
                itemProp="description"
                dangerouslySetInnerHTML={{
                  __html: this.props.context.getIn(["webProduct", "description"], "")
                }}
              />
            </ReadMore>,
            <div className="Cart__Product__Price" key="ProductPrice">
              <div className="productcard__info__price__from">{this.props.t("from")}</div>
              <div className="productcard__info__price__currency">&euro;</div>
              <div className="productcard__info__price__price">
                {price(this.props.currentItemContext.getIn(["items", 0, "priceIn"]), false)}
              </div>
            </div>
          ]}
          <div className="Cart__Product__Discount" />
        </StickyContainer>
      </div>,
      <ReactTooltip effect="solid" key="Cart__Tooltip" />
    ];
  }
}

const EMPTY_LIST = Immutable.List();

const cartFormValueSelector = formValueSelector("cart");

const selectCartFormItemsData = createSelector(
  [state => cartFormValueSelector(state, "items")],
  cart => Immutable.fromJS(cart)
);

const selectCartContext = createSelector(
  [state => state.cart],
  cart => (cart && cart.get("context", EMPTY_MAP)) || EMPTY_MAP
);

const selectCartItems = createSelector(
  [state => selectCartFormItemsData(state), state => selectCartContext(state)],
  (items, context) => {
    const itemContexts = context.get("itemContexts");
    if (!itemContexts || !items) {
      return EMPTY_LIST;
    }
    return items
      .map(item => {
        const itemContext = itemContexts.find(ctx => ctx.get("webProductId") === item.get("webProductId"));
        // console.log('itemContext', itemContext);
        if (!itemContext) {
          return null;
        }
        let pcm = itemContext.get("items").find(i => i.get("id") === item.get("productCollectionMemberId"));
        // console.log('pcm', pcm);
        if (!pcm) {
          return null;
        }

        pcm = pcm.set("uuid", item.get("uuid"));
        pcm = pcm.set("webProductId", item.get("webProductId"));
        pcm = pcm.set("title", `${pcm.get("title")}`);
        pcm = pcm.set("quantity", item.get("quantity"));
        pcm = pcm.set("imageId", itemContext.get("imageId"));
        pcm = pcm.set("imageVersionId", itemContext.get("imageVersionId"));

        const extraProducts = itemContext.get("extraProducts");
        pcm = pcm.set(
          "extraProducts",
          item
            .get("extraProducts")
            .map(p => {
              const ep = extraProducts.find(i => i.get("id") === p.get("id"));
              if (!ep) {
                return null;
              }
              return ep.set("uuid", p.get("uuid")).set("quantity", item.get("quantity"));
            })
            .filter(v => !!v)
        );
        return pcm;
      })
      .filter(v => !!v);
  }
);

const selectCartQuantity = createSelector(
  [state => selectCartItems(state, "items")],
  items => {
    if (!items) {
      return 0;
    }
    return Immutable.fromJS(items).reduce((carry, item) => {
      carry = carry + item.get("quantity") + item.get("extraProducts").size;
      return carry;
    }, 0);
  }
);

const selectCart = createSelector(
  [state => state.cart],
  cart => cart
);

const selectCartData = createSelector(
  [state => selectCart(state)],
  cart => cart.get("data")
);

const selectCartFormData = createSelector(
  [state => state.form.cart],
  cart => cart && cart.values
);

const selectInitialValues = createSelector(
  [state => selectCartData(state), state => state.cart.get("context")],
  (cart, context) => {
    // preselect only paymentmethod
    const paymentMethods = context.get("paymentMethods");
    if (paymentMethods && paymentMethods.size === 1) {
      cart = cart.setIn(["checkout", "payment", "type"], paymentMethods.getIn([0, "id"]));
    }

    if (context.get("isBusinessAccount") && context.get("customerContext", null)) {
      cart = cart.set("customer", context.get("customerContext"));
    }

    cart = cart.set(
      "recipients",
      cart.get("recipients").map((r, idx) => {
        const recipientContext = context.getIn(["recipientContexts", idx]);
        if (!recipientContext) {
          return r;
        }

        // preselect first timeframe
        const availableTimeFrames = recipientContext.get("availableTimeFrames");
        if (availableTimeFrames && availableTimeFrames.size === 1) {
          r = r.setIn(["delivery", "timeFrame"], availableTimeFrames.getIn([0, "id"]));
        }

        // preselect card based on default card
        const availableCards = recipientContext.get("availableCards");
        if (availableCards && availableCards.size > 0) {
          const currentCardId = r.getIn(["card", "type"]);
          if (availableCards.findIndex(c => c.get("id") === currentCardId) === -1) {
            r = r.setIn(["card", "type"], recipientContext.get("defaultCard", 0));
          }
        }
        return r;
      })
    );

    return cart.toJS();
  }
);

const selectSchema = createSelector(
  [state => selectCartFormData(state), state => selectCartContext(state), state => selectCart(state).get("schema")],
  (data, context, schema) => {
    if (
      data &&
      data.customer &&
      data.customer.type === "business" &&
      data.checkout &&
      data.checkout.payment &&
      data.checkout.payment.type === context.getIn(["constants", "ID_BILLINK"])
    ) {
      schema = schema
        .setIn(["properties", "customer", "properties", "cocNumber", "minLength"], 1)
        .setIn(
          ["properties", "customer", "required"],
          schema.getIn(["properties", "customer", "required"]).push("cocNumber")
        );
    }
    return schema;
  }
);

const selectSchemaValidator = createSelector(
  [state => selectSchema(state)],
  createSchemaValidator
);

const selectFormSubmitErrors = getFormSubmitErrors("cart");

const selectFormAsyncErrors = getFormAsyncErrors("cart");
const selectFormSyncErrors = getFormSyncErrors("cart");

const reduxFormCfg = {
  form: "cart",
  validate,
  onSubmitFail: reduxFormOnSubmitFailScrollToFirstError
};

if (!hasClass("ie-lte-9")) {
  reduxFormCfg.asyncValidate = (data, dispatch, props, field) => {
    if (__DEV__) {
      // eslint-disable-next-line no-console
      console.log("asyncValidate, data, field", data, field);
    }
    const errors = validate(data, props, field);
    if (Object.keys(errors).length > 0) {
      return Promise.reject(errors);
    }
    return Promise.resolve();
  };
}

const selectCurrentItemContext = createSelector(
  [state => selectCartContext(state)],
  context => context.get("currentItemContext")
);

const selectWebProduct = createSelector(
  [state => selectCartContext(state)],
  context => context.get("webProduct")
);

const selectIsCurrentItemContextInCart = createSelector(
  [state => selectCartFormData(state), state => selectWebProduct(state)],
  (formData, webProduct) =>
    formData && formData.items && formData.items.find(i => i.uuid === webProduct.get("uuid")) !== undefined
);

const getGOptimizeExperimentVariant = experimentId =>
  window.google_optimize && window.google_optimize && window.google_optimize.get(experimentId);

export default hot(module)(
  translate()(
    withRouter(
      connect(
        state => {
          const formValues = selectCartFormData(state);
          const context = selectCartContext(state);
          const cart = selectCart(state);
          return {
            isSafari: context.getIn(["detect", "client", "name"], "").toLowerCase() === "safari",
            isFirstShow: cart.get("isFirstShow"),
            isAbTestOpenStep2: !!(
              getGOptimizeExperimentVariant("MOQRseO7Qlek4EQXcSXBPw") === "1" ||
              (__DEV__ && localStorage.getItem("isAbTestOpenStep2"))
            ),
            isCartEmpty: selectCartQuantity(state) === 0,
            context,
            isKmtUser: state.cart.getIn(["context", "isKmtUser"], false),
            isMobileView: state.app.get("isMobileView"),
            isBusinessAccount: state.cart.getIn(["context", "isBusinessAccount"], false),
            isCurrentItemInCart: state.cart.getIn(["settings", "currentItemInCart"], false),
            currentItemContext: selectCurrentItemContext(state),
            isCurrentItemContextInCart: selectIsCurrentItemContextInCart(state),
            webProductCollection: state.cart.getIn(["context", "webProductCollection"]),
            activeStep: cart.get("activeStep"),
            canFinalize: true,
            initialValues: selectInitialValues(state),
            schema: selectSchema(state),
            schemaValidator: selectSchemaValidator(state),
            formValues,
            formSubmitErrors: selectFormSubmitErrors(state),
            formAsyncErrors: selectFormAsyncErrors(state),
            formSyncErrors: selectFormSyncErrors(state),
            isHydratingContext: state.cart.get("isFetchingContext", false),
            enableReinitialize: true,
            keepDirtyOnReinitialize: true,
            updateUnregisteredFields: true,
            forceUnregisterOnUnmount: true,
            destroyOnUnmount: false
          };
        },
        {
          blurField: formActions.blur,
          touchField: formActions.touch,
          changeField: formActions.change,
          pushDataLayerEvent,
          submitCart,
          initCart,
          calcCart,
          hydrateContext,
          setActiveStep,
          formClearSyncErrors,
          formClearAsyncErrors
        }
      )(reduxForm(reduxFormCfg)(Container))
    )
  )
);
